export const NOTIFICATION = {
  INVALID_LOGIN: 'Unable to login with provided credentials!',
  INVALID_THREAD: 'Unable to create new thread',
  THREAD_CREATED: 'Thread successfully created',
  THREAD_UPDATED: 'Thread successfully updated',
  THREAD_DELETED: 'Thread successfully deleted',
  THREAD_ARCHIVED: 'Thread successfully archived',
  REFERENCE_CREATED: 'Reference successfully created',
  REFERENCE_UPDATED: 'Reference successfully updated',
  REFERENCE_DELETED: 'Reference successfully deleted',
  USER_INVITE_SUCCESS: 'User successfully invited',
  USER_INVITE_DELETED: 'User successfully deleted',
  CONTRIBUTOR_CREATED: 'Contributor successfully has been added',
  CONTRIBUTOR_DELETED: 'Contributor successfully deleted',
  RESOURCE_CREATED: 'Resource successfully created',
  RESOURCE_DELETED: 'Resource successfully deleted',
  RELATED_THREAD_CREATED: 'Related thread successfully created',
  RELATED_THREAD_DELETED: 'Related thread successfully deleted',
  ADD_TAGS: 'Tags successfully added',
  SOMETHING_WRONG: 'Oops! Something went wrong. Try again.',
  MAX_SIZE_UPLOAD: 'The limit has been exceeded, the maximum file size is 50 MB',
  ACCOUNT_CREATED: 'Account created successfully',
  INVALID_INVITE_LINK: 'Invalid link! Check your invitation link and try again',
  REQUEST_SENT: 'Request successfully sent',
  PASSWORD_CHANGED: 'Password successfully changed',
  MESSAGE_DELETED: 'Message successfully deleted',
  EVENT_CREATED: 'Event successfully created',
  EVENT_DELETED: 'Event successfully deleted',
  EVENT_UPDATED: 'Event successfully updated',
  EVENT_404: 'Event not found. Verify the event ID and try again.',
  PROFILE_UPDATED: 'Profile successfully updated',
  INVALID_PASSWORD: 'Wrong password',
  THREAD_NOT_FOUND: 'Thread not found',
  PAGE_NOT_FOUND: 'Page not found',
  EMAIL_NOTIFICATION_PERMISSION: 'Email notification permission successfully updated',
  UPDATE_MEMBER_ROLE: 'Member role successfully updated',
  CLIPBOARD_COPY_FAILURE:
    'Error occurred in trying to copy to clipboard, please check your browser settings and try again.',
  BOM_SUCCESS: 'Bill of Material saved succesfully',
  BOM_FAILURE: 'Bill of Material failed to save',
  BOM_GET_FAILURE: 'Failed to get Bill of Material data.',
  BOM_ITEM_SUCCESS: 'Part successfully saved to Bill of Materials',
  BOM_ITEM_FAILURE: 'Part failed to save to Bill of Materials',
  BOM_ITEM_DELETE_SUCCESS: 'Part successfully deleted from Bill of Materials',
  BOM_ITEM_DELETE_FAILURE: 'Part could not be deleted from Bill of Materials',
  DRAWING_ADD_SUCCESS: 'Drawing successfully added',
  DRAWING_ADD_FAILURE: 'Drawing could not be added',
  DRAWING_DELETE_SUCCESS: 'Drawing successfully removed',
  DRAWING_DELETE_FAILURE: 'Drawing could not be removed',
  DRAWING_GET_FAILURE: 'Failed to get drawing data.',
  REFERENCE_GET_FAILURE: 'Failed to get reference data.',
  SSO_NOT_CONFIGURED:
    'Single sign-on is not configured for this workspace. Contact your administrator.',
  SSO_FAILED: 'We could not complete the single sign-on. Please start the login again.',
  MFA_CODE_REFUSED:
    'We were unable to sign you in using the provided code. The code may be incorrect, expired, or ' +
    'already used. Please start the sign-in process again to request a new code. Repeated unsuccessful ' +
    'attempts may result in a temporary sign-in block.',
  MFA_UNSUPPORTED:
    'This workspace needs a verification step this version of Threads cannot complete. Contact your administrator.',
  MFA_CODE_NOT_SENT:
    'We could not send your verification code. Please try again in a few minutes, ' +
    'or contact your administrator if this continues.',
  ACCOUNT_LOCKED:
    'Too many unsuccessful attempts have been made. Sign-in has been temporarily blocked. ' +
    'Please try again later or contact your administrator.',
  ACCOUNT_LOCKED_FOR: 'Too many failed attempts. You can try signing in again in {wait}. ',
};
